import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-debt-type-confirmation',
  templateUrl: './debt-type-confirmation.component.html',
  styleUrl: './debt-type-confirmation.component.scss'
})
export class DebtTypeConfirmationComponent implements OnInit {
  event_id: any;
  today_year: any;
  debt_type: any;
  debt_status:any;
  
  constructor(private route: Router, private _activatedRoute: ActivatedRoute){}
  ngOnInit(){
    this._activatedRoute.queryParams.subscribe((data: any) => {
      if(data){
        this.debt_type = data.debt_type
        if(this.debt_type == 1){
          this.debt_status = 'Consumer';
        }else{
          this.debt_status = 'Commercial';
        }
      }else{
        this.route.navigate(["/app/dashboard"]);
      }
    });
    this.today_year = new Date().getFullYear();
  }
  dashboard(){
    this.route.navigate(["/app/dashboard"]);
  }
  debtType(type: any){
    this.route.navigate([`/app/debt-recuvery-${type == 1 ? '' : 'comercial'}`])
  }
}
